/** Понятные сообщения об ошибках сохранения доски. */
export function boardSaveErrorMessage(err: {
  code?: string;
  message?: string;
} | null | undefined): string {
  const code = err?.code;
  if (code === "schema_outdated") {
    return "База данных на сервере устарела — попросите администратора выполнить миграции";
  }
  if (code === "internal_error") {
    return "Ошибка сервера при сохранении — попробуйте обновить страницу";
  }
  if (code === "forbidden") {
    return "Нет прав на редактирование доски";
  }
  if (code === "rate_limited") {
    return "Слишком много изменений подряд — сервер не успевает их сохранять. Подождите пару секунд";
  }
  if (code === "revision_conflict") {
    return "Конфликт версий — доска обновлена с сервера";
  }
  if (code === "scene_too_large") {
    return "Доска переполнена — сервер больше не принимает изменения. Перенесите часть материала на новую доску или удалите лишнее";
  }
  if (code === "plan_board_full") {
    return "На бесплатном тарифе доска заполнена. Начните новую доску или перейдите на Pro — там досок без лимита";
  }
  if (code === "too_many_objects") {
    return "На доске слишком много объектов — часть нужно удалить или перенести на другую доску";
  }
  if (code === "op_rejected") {
    return err?.message || "Сервер отклонил изменение";
  }
  if (code === "invalid_input") {
    return "Не удалось сохранить штрих (сервер отклонил данные)";
  }
  const msg = err?.message;
  if (msg && msg.includes("ops_ack timeout")) {
    return "Сохранение не успело подтвердиться — проверьте сеть";
  }
  if (msg === "Internal Server Error") {
    return "Ошибка сервера при сохранении — попробуйте обновить страницу";
  }
  return msg || "Не удалось сохранить";
}

export function boardWsStatusMessage(detail: string): string {
  if (detail === "forbidden") return "Нет доступа к realtime";
  if (detail === "internal_error") {
    return "Ошибка соединения с сервером — рисование может не сохраняться";
  }
  if (detail === "schema_outdated") {
    return "База данных на сервере устарела — выполните миграции API";
  }
  if (detail === "unknown_message" || detail === "неизвестное_сообщение") {
    return "Сбой realtime-сообщения — обновите страницу, если рисование не сохраняется";
  }
  if (detail === "Invalid input" || detail === "invalid_input") {
    return "Сервер отклонил изменение (некорректные данные штриха)";
  }
  if (detail === "not_subscribed") {
    return "Нет подключения к доске — обновите страницу";
  }
  return detail;
}
